import { devEnvAttentionLog } from '~/utils/debug.utils';
import { useEffectOnce } from 'react-use';
import { isDevelopment } from '~/utils/environment.utils';
import { useIsWrappedWithMXStatsigProvider } from '~/common/Statsig/Authenticated/MX/useIsWrappedWithMXStatsigProvider';
import { useIsWrappedWithCXStatsigProvider } from '~/common/Statsig/Authenticated/CX/useIsWrappedWithCXStatsigProvider';
import { useIsWrappedWithUnauthenticatedStatsigProvider } from '~/common/Statsig/Unauthenticated/useIsWrappedWithUnauthenticatedStatsigProvider';

export const useWarnAboutMissingStatsigProvider = (
    propsToLog: Record<string, string>
) => {
    const isWrappedWithMXStatsigProvider = useIsWrappedWithMXStatsigProvider();
    const isWrappedWithCXStatsigProvider = useIsWrappedWithCXStatsigProvider();
    const isWrappedWithUnauthenticatedStatsigProvider =
        useIsWrappedWithUnauthenticatedStatsigProvider();

    useEffectOnce(() => {
        if (
            !isWrappedWithMXStatsigProvider &&
            !isWrappedWithCXStatsigProvider &&
            !isWrappedWithUnauthenticatedStatsigProvider &&
            isDevelopment()
        ) {
            devEnvAttentionLog(
                ` You are using a Statsig gate/experiment/dynamic_config without an HBStatsigProvider. Please wrap your component with an HBStatsigProvider.\n${JSON.stringify(
                    propsToLog,
                    null,
                    1
                )}`
            );
        }
    });
};
